import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ScanLine } from 'lucide-react';

// Floating "AI Scan" button, MOBILE ONLY (the .inv-mobile-fab CSS hides it on
// desktop). Scanning a card is the core action, so it gets a persistent,
// always-reachable button on every in-app page. Sits bottom-LEFT, mirroring the
// assistant chat bubble on the bottom-right (one action per thumb corner).
export default function MobileScanFab() {
  const navigate = useNavigate();
  const location = useLocation();
  // Hidden on the dashboard, the "Add Inventory" button is right there, so the
  // FAB just adds clutter to the already-busy first screen. Kept on every other
  // page as the persistent scan shortcut.
  if (location.pathname === '/') return null;
  return (
    <button
      className="inv-mobile-fab"
      onClick={() => navigate('/inventory?scan=1')}
      aria-label="AI Scan a card"
    >
      <ScanLine size={22} strokeWidth={2.4} />
      <span className="inv-mobile-fab-label">AI Scan</span>
    </button>
  );
}
